import { Group, Text } from '@mantine/core';

import LegendDot from './AvailabilityCalendar.legend-dot';

type CalendarLegendProps = {
  targetMonth: string;
};

const CalendarLegend: React.FC<CalendarLegendProps> = ({ targetMonth }) => (
  <Group gap="md" mb="sm" wrap="nowrap" w="auto" justify="space-between">
    <Text size="sm" fw={700}>
      {targetMonth}
    </Text>
    <Group gap="xs" wrap="nowrap">
      <LegendDot color="green" label="Available" />
      <LegendDot color="red" label="Unavailable" />
    </Group>
  </Group>
);

export default CalendarLegend;
